import { CommonEnums } from '../../common.enums';
import { Usr_Def_Fun } from './usr_def_fun';
import { ArrayUtil } from '../utils/array.util';

export class UDF {
    usr_Def_Fun: Usr_Def_Fun;
    fldr_Id: number;
    lockBy: string;
    change_Ind: string;
    mode_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string
    ref_Id: number;
    ref_Cd: string;
    reusableFlag: string;
    isDependent: boolean;
    isLinkExist: boolean;
    fldrNm: string;
    imageUrl: string;
    isRecExists: boolean;
    dependent_Ids: Array<number>;
    selectedFlag: string;
    fldr_Cd: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.usr_Def_Fun = new Usr_Def_Fun();
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.lockBy = CommonEnums.unlock_Ind.UNSET;
        this.change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.unlock_Ind = CommonEnums.defaults.UNLOCK_IND_UNSET;
        this.ref_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.isDependent = false;
        this.isLinkExist = false;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.isRecExists = false;
        this.dependent_Ids = new Array<number>();
        this.selectedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: any): UDF {
        let uDF: UDF = new UDF();
        uDF.copyFrom(object as UDF);
        return uDF;
    }

    copy(): UDF {
        let uDFTmp: UDF = new UDF();

        uDFTmp.usr_Def_Fun = this.usr_Def_Fun.copy();
        uDFTmp.fldr_Id = this.fldr_Id;
        uDFTmp.lockBy = this.lockBy;
        uDFTmp.change_Ind = this.change_Ind
        uDFTmp.mode_Ind = this.mode_Ind
        uDFTmp.unlock_Ind = this.unlock_Ind;
        uDFTmp.error_Cd = this.error_Cd;
        uDFTmp.error_Msg = this.error_Msg;
        uDFTmp.ref_Id = this.ref_Id;
        uDFTmp.ref_Cd = this.ref_Cd
        uDFTmp.reusableFlag = this.reusableFlag;
        uDFTmp.isDependent = this.isDependent;
        uDFTmp.isLinkExist = this.isLinkExist;
        uDFTmp.fldrNm = this.fldrNm;
        uDFTmp.imageUrl = this.imageUrl;
        uDFTmp.isRecExists = this.isRecExists;
        uDFTmp.dependent_Ids = ArrayUtil.getInstance().copy(this.dependent_Ids);
        uDFTmp.selectedFlag = this.selectedFlag;
        uDFTmp.fldr_Cd = this.fldr_Cd;

        return uDFTmp;
    }

    copyFrom(uDFTmp: UDF): void {
        this.usr_Def_Fun.copyFrom(uDFTmp.usr_Def_Fun);
        this.fldr_Id = uDFTmp.fldr_Id;
        this.lockBy = uDFTmp.lockBy;
        this.change_Ind = uDFTmp.change_Ind;
        this.mode_Ind = uDFTmp.mode_Ind;
        this.unlock_Ind = uDFTmp.unlock_Ind;
        this.error_Cd = uDFTmp.error_Cd;
        this.error_Msg = uDFTmp.error_Msg;
        this.ref_Id = uDFTmp.ref_Id;
        this.ref_Cd = uDFTmp.ref_Cd;
        this.reusableFlag = uDFTmp.reusableFlag;
        this.isDependent = uDFTmp.isDependent;
        this.isLinkExist = uDFTmp.isLinkExist;
        this.fldrNm = uDFTmp.fldrNm;
        this.imageUrl = uDFTmp.imageUrl;
        this.isRecExists = uDFTmp.isRecExists;
        ArrayUtil.getInstance().copyFrom(this.dependent_Ids, uDFTmp.dependent_Ids);
        this.selectedFlag = uDFTmp.selectedFlag;
        this.fldr_Cd = uDFTmp.fldr_Cd;
    }

    compare(uDFTmp: UDF): string {
        let diffString: string = this.usr_Def_Fun.compare(uDFTmp.usr_Def_Fun);
        if (diffString != '') return diffString;

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "UDF ['usr_Def_Fun: '" + this.usr_Def_Fun.toString() + ", reusableFlag=" + this.reusableFlag +
            ", isDependent=" + this.isDependent + ", isLinkExist" + this.isLinkExist +
            ", isRecExists+" + this.isRecExists + ", dependent_Ids" + this.dependent_Ids +
            ", selectedFlag" + this.selectedFlag;

        if (isNotCompare) {
            str += ", fldr_Id =" + this.fldr_Id + ", fldrNm" + this.fldrNm + ", imageUrl" + this.imageUrl +
                ", lockBy = " + this.lockBy + ", change_Ind=" + this.change_Ind + ", mode_Ind=" + this.mode_Ind +
                ", unlock_Ind=" + this.unlock_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", fldr_Cd" + this.fldr_Cd;
        }

        str += "]";
        return str;
    }
}